/**
 * A long run of digits after the name — the payment reference the bank puts after a person who sent money
 * ("K STANKOWSKA 600000001844463762"; the owner, 01.10.2026: „ten numer? co z nim”). Ten digits or more, so a shop
 * number ("Tesco 2041") stays; a name that is only a number has nothing before it and stays too.
 */
const REFERENCE = /[\s,.-]+\d{10,}[\s,.]*$/;

/** The name without the bank's payment reference at its end; the full bank text stays in the description. */
export function withoutReference(text: string): string {
  return text.replace(REFERENCE, '').trim();
}

/** "OCTOPUS ENERGY" → "Octopus Energy"; short words ("EE", "UK") stay as they are; no payment reference. */
export function tidyName(text: string | null): string | null {
  const trimmed = text ? withoutReference(text.trim()) : '';
  if (!trimmed) return null;
  if (trimmed !== trimmed.toUpperCase()) return trimmed.slice(0, 120);
  return trimmed
    .split(/\s+/)
    .map((word) => (word.length <= 2 || /\d/.test(word) ? word : word.charAt(0) + word.slice(1).toLowerCase()))
    .join(' ')
    .slice(0, 120);
}
